import { getContract } from 'viem';
import { useSearchParams } from 'react-router-dom';

// Config
import { abiStorage, PRIVY_SALE_ADDRESS, PRESALE_VESTING_ADDRESS } from '../config';

export const useContract = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('active-tab');
  const isOldContract = activeTab === 'old-contract';

  const contract = getContract({
    address: isOldContract ? PRIVY_SALE_ADDRESS : PRESALE_VESTING_ADDRESS,
    abi: abiStorage[isOldContract ? 'PrivySale' : 'PresaleVesting'].abi,
  });

  return { contract };
};
